import { useLayoutEffect, useRef, useState } from "react";
import { Sidebar } from "@/components/layout/Sidebar";
import { Header } from "@/components/layout/Header";
import { Breadcrumbs } from "@/components/layout/Breadcrumbs";
import { CommandPalette } from "@/components/layout/CommandPalette";
import { useAdminSettings } from "@/hooks/useAdminSettings";

export function AdminShell({ children }: { children: React.ReactNode }) {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const backgroundRef = useRef<HTMLDivElement>(null);
  const returnFocusRef = useRef<HTMLElement | null>(null);
  // Sync DB → localStorage on boot (P1 fix: ensures all 19 consumers read shared values)
  useAdminSettings();

  useLayoutEffect(() => {
    backgroundRef.current?.toggleAttribute("inert", mobileSidebarOpen);
  }, [mobileSidebarOpen]);

  function openMobileSidebar() {
    returnFocusRef.current = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    setMobileSidebarOpen(true);
  }

  return (
    <div className="flex h-dvh min-h-0 overflow-hidden bg-background">
      <Sidebar
        mobileOpen={mobileSidebarOpen}
        onCloseMobile={() => setMobileSidebarOpen(false)}
        returnFocusRef={returnFocusRef}
      />
      <div
        ref={backgroundRef}
        className="flex min-h-0 min-w-0 flex-1 flex-col"
        data-testid="admin-shell-background"
        aria-hidden={mobileSidebarOpen ? "true" : undefined}
      >
        <Header onOpenMobileSidebar={openMobileSidebar} />
        <Breadcrumbs />
        <main className="min-h-0 min-w-0 flex-1 overflow-auto p-0 sm:p-6">{children}</main>
      </div>
      <CommandPalette disabled={mobileSidebarOpen} />
    </div>
  );
}
